import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Music2 } from "lucide-react";
import DailyCreativePreviewCard from "@/components/admin/DailyCreativePreviewCard";
import ChannelSettingsCard from "@/components/admin/ChannelSettingsCard";
import MetaSocialCard from "@/components/admin/MetaSocialCard";

const TikTokComingSoonCard = () => (
  <Card className="border-dashed">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-base">
        <div className="w-7 h-7 rounded-md bg-foreground/5 text-foreground flex items-center justify-center border">
          <Music2 className="w-4 h-4" />
        </div>
        <span className="flex-1">TikTok — Daily Post</span>
        <Badge variant="outline" className="text-[10px]">Coming soon</Badge>
      </CardTitle>
    </CardHeader>
    <CardContent className="text-xs text-muted-foreground space-y-2">
      <p>
        Once TikTok approves the Content Posting API for our app, this card
        will mirror the Meta one: connection status, schedule, "Post now",
        and recent post history with retry — all using the same shared daily
        creative as Telegram, Facebook, and Instagram.
      </p>
      <p className="text-[11px]">
        Pending: TikTok app review (5–10 business days) +{" "}
        <code className="text-[10px]">TIKTOK_CLIENT_KEY</code> /{" "}
        <code className="text-[10px]">TIKTOK_CLIENT_SECRET</code>.
      </p>
    </CardContent>
  </Card>
);

const SocialChannelsTab = ({ sessionToken }: { sessionToken: string | null }) => {
  return (
    <div className="space-y-4">
      <DailyCreativePreviewCard />
      <ChannelSettingsCard sessionToken={sessionToken} />
      <MetaSocialCard sessionToken={sessionToken} />
      <TikTokComingSoonCard />
    </div>
  );
};

export default SocialChannelsTab;
